import { render, staticRenderFns } from "./editCurrency.vue?vue&type=template&id=74277066"
import script from "./editCurrency.vue?vue&type=script&lang=js"
export * from "./editCurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports